/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PspData } from "./PspData";
import * as t from "io-ts";

// required attributes
const PspDataListResponseR = t.interface({
  data: t.readonlyArray(PspData, "array of PspData")
});

// optional attributes
const PspDataListResponseO = t.partial({});

export const PspDataListResponse = t.intersection(
  [PspDataListResponseR, PspDataListResponseO],
  "PspDataListResponse"
);

export type PspDataListResponse = t.TypeOf<typeof PspDataListResponse>;
